import ChartView from './ChartView';
import './ChartView.scss';

export default ChartView;